<template>
  <div class="mentIndex">
    <div class="home_con">
      <div style="width:306px"></div>

      <div class="mentCon">
        <div class="ment_title">数据传输</div>
        <p>1.1 接口调用方式</p>
        <span
          >所有接口均使用 HTTP(S)/POST 方式传输参数,采用 JSON
          的方式,传输过程中包含请求头和请求主体两部分。</span
        >

        <p>1.2 请求头规范</p>
        <span
          >请求头需包含内容类型（Content-Type）和授权信息（Authorization）。</span
        ><br />
        <span
          >Content-Type：
          用于标识请求中的请求主体的编码方式，本标准中所规范的信息交换内容均采用
          JSON 的方式，参数信息采用 UTF-8 编码，因此需要配置请求头中
          Content-Type 为 application/json; charset=utf-8。</span
        >

        <p>1.3 请求体规范</p>
        <small>1.3.1 请求</small>
        <span
          >由运营商唯一标识（OperatorID）、请求参数内容（Data）、时间戳（TimeStamp）、自增序列（Seq）和数字签名（Sig）组成。</span
        >
        <img src="@/assets/ment/1.png" alt="" />
        <small>1.3.2 响应</small>
        <span
          >响应参数由返回值（Ret）、返回信息（Msg）、参数内容（Data）和数字签名（Sig）组成。</span
        >
        <img src="@/assets/ment/2.png" alt="" />
        <small>1.4 性能约束</small>
        <img src="@/assets/ment/3.png" alt="" />
      </div>
    </div>
  </div>
</template>


<script>
import Ment from "@/components/ment";
export default {
  components: {
    Ment,
  },
  data() {
    return {
      flag: false,
    };
  },
  mounted() {
  
  },
  methods: {},
};
</script>


<style>
.el-menu{
  border:none!important;
}
</style>
<style scoped>
.home_con {
  width:1000px!important;
  max-width:0px!important;
  display: flex;
  text-align: left;
  
}
</style>


// WEBPACK FOOTER //
// src/page/document/documenta_1.vue